export default __webpack_public_path__ + "static/media/header_logo.dfff5039.png";